import React, { Component } from "react";
import Header from "../components/Header/index";
import Footer from "../components/Footer/index";
import Complaint from "../components/Customer/add-complaint";
import { Redirect } from "react-router-dom";

class CustomerComplaint extends Component<{ history: any }, {}> {
  componentDidMount() {
    // document.title = "Feedback - Tortilla";
    document.title = "Feedback - Kyochon"
  }
  render() {
    // if (!localStorage.mainToken) {
    //   return <Redirect to="/landing" />
    // }
    return (
      <div className="page-wrapper">
        <div id="page-wrap">
          <Header history={this.props.history} />
          <Complaint />
          <Footer />
        </div>
      </div>
    );
  }
}

export default CustomerComplaint;
